import { DownloadKeys } from 'enums/GraphDropdownEnums';
import { downloadProductMap } from './HelperFunctions';

export const downloadGraph = async (
  key: string,
  graph: React.RefObject<HTMLDivElement>,
  name: string,
  setIsDownloading: (downloading: boolean) => void
) => {
  if (key === DownloadKeys.JPG || key === DownloadKeys.PNG) {
    if (!(graph?.current && setIsDownloading)) return;
    if (graph.current) {
      setIsDownloading(true);
      setTimeout(async () => {
        await downloadProductMap(graph, key, name);
        setIsDownloading(false);
      }, 150);
    }
  }
};
